import { useState, useEffect } from 'react';
import { BancaViewModel } from '../../../viewmodel/banca/BancaViewModel';
import { EnumBancaViewModel } from '../../../viewmodel/banca/EnumBancaViewModel';
import { TipoBanca } from '../../../model/banca/Banca';
import { BancaNovaResponse } from '../../../model/banca/BancasNovaResponse';

export const useBancasData = (processoId: string | undefined, temPermissao: boolean) => {
  const [bancas, setBancas] = useState<BancaNovaResponse[]>([]);
  const [tiposBanca, setTiposBanca] = useState<TipoBanca[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const pageSize = 10;

  const fetchBancas = async (page: number = 0) => {
    if (!temPermissao || !processoId) return;
    setLoading(true);
    try {
      const result = await BancaViewModel.getBancasNova(processoId, page, pageSize);
      setBancas(result._embedded.bancasNovaResponseList);
      setCurrentPage(result.page.number);
      setTotalPages(result.page.totalPages);
      setTotalElements(result.page.totalElements);
    } catch (error) {
      console.error('Erro ao buscar bancas:', error);
      setBancas([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTiposBanca = async () => {
    try {
      const tipos = await EnumBancaViewModel.getTiposBanca();
      setTiposBanca(tipos);
    } catch (error) {
      console.error('Erro ao buscar tipos de banca:', error);
    }
  };

  useEffect(() => {
    if (temPermissao && processoId) {
      fetchBancas(0);
      fetchTiposBanca();
    }
  }, [temPermissao, processoId]);

  return {
    bancas,
    tiposBanca,
    loading,
    currentPage,
    totalPages,
    totalElements,
    pageSize,
    refetchBancas: () => fetchBancas(currentPage),
    goToPage: fetchBancas
  };
};